import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';

import { firstValueFrom, map } from 'rxjs';
import { AuthGuardData, createAuthGuard } from 'keycloak-angular';
import Keycloak from 'keycloak-js';

import { AuthenticationService } from '../services/authentication.service';
import { User } from '../models/user';

const loadUser = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot, authData: AuthGuardData): Promise<boolean> => {
  const authenticationService = inject(AuthenticationService);
  const keycloak = inject(Keycloak);
  const { authenticated } = authData;
  
  if (authenticated) {
    return firstValueFrom(authenticationService.getUser().pipe(
      map((user: User) => {
        if (user.id) {
          return true;
        } else {
          keycloak.logout();
          return false;
        }
      })
    ));
  }

  keycloak.login();
  return false;
};

export const authGuard = createAuthGuard<CanActivateFn>(loadUser);
